export default {
  props: ['cart_total'],
  data() {
    return {
      barWidth: 0,
      freeShippingThreshold: 10000
    }
  },
  mounted() {
    this.updateBarWidth(this.cart_total);
  },
  methods: {
    formatPrice(num) {
      return `$${(num / 100).toFixed(2)}`;
    },
    moneyToGo() {
      return this.freeShippingThreshold - this.cart_total;
    },
    width(n) {
      const percent = (n / this.freeShippingThreshold) * 100;
      return percent > 100 ? 100 : percent;
    },
    updateBarWidth(total) {
      this.barWidth = this.width(total);
    },
  },
  computed: {
    isFull() {
      return this.barWidth >= 100;
    },
  },
  watch: {
    cart_total(newVal, oldVal) {
      this.updateBarWidth(newVal);
      if (newVal !== oldVal) {
        if (newVal > oldVal) {
          // this.barWidth = 100;
          // setTimeout(() => {
          //   this.barWidth = 0;
          // }, 1000);
          setTimeout(() => {
            this.updateBarWidth(newVal);
          }, 1200);
        }

        if (newVal < oldVal) {
          this.barWidth = 0;
          setTimeout(() => {
            this.barWidth = 99;
          }, 1000);
          setTimeout(() => {
            this.updateBarWidth(newVal);
          }, 1200);
        }
      }
    },
  },
  template:`
  <div class="progress_bar_section" :class="{ full : isFull }">
    <p v-if="cart_total <= this.freeShippingThreshold" class="progress_bar_title">Add {{formatPrice(this.moneyToGo())}} to unlock Free Shipping </p>
    <p v-else class="progress_bar_title">You've unlocked Free Shipping</p>
    <div class="progress_bar_wrapper">  
      <div v-if=" this.barWidth < 100" class="vue_progress_bar" :style="{ width: this.barWidth + '%' }"></div>
      <div v-else class="vue_progress_bar" style="width:100%"></div>
    </div>
  </div>
  `
}